import { useState, useRef, useEffect } from 'react';
import Image from 'next/image';
import { Typography } from '@mui/material';
import Cookies from 'js-cookie';
import i18n from 'i18next';
import { ChevronDown } from 'react-feather';
import { CHANGE_LANG } from 'context/actions/system';

const LanguageChanger = ({ style = '', languages, chosedLang, setChoosedLang, dispatch }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef();

    // Гадна дарахад хаах
    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    const handleSelect = (lng) => {
        setChoosedLang(lng);
        i18n.changeLanguage(lng.code);
        if (typeof window !== 'undefined') Cookies.set('chosen_lang', lng.code);
        dispatch({ type: CHANGE_LANG, data: lng.code });
        setOpen(false);
    };

    return (
        <div ref={ref} style={{ position: 'relative', display: 'inline-flex' }} className={style}>
            {/* Trigger */}
            <button
                onClick={() => setOpen((p) => !p)}
                style={{
                    all: 'unset',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                    padding: '3px 7px',
                    borderRadius: 6,
                    transition: 'background .15s',
                    background: open ? 'rgba(0,0,0,0.06)' : 'transparent',
                }}
                onMouseEnter={(e) => {
                    if (!open) e.currentTarget.style.background = 'rgba(0,0,0,0.04)';
                }}
                onMouseLeave={(e) => {
                    if (!open) e.currentTarget.style.background = 'transparent';
                }}
            >
                {chosedLang?.flagUrl && (
                    <Image
                        width={18}
                        height={18}
                        src={chosedLang.flagUrl}
                        alt={chosedLang.name}
                        style={{ objectFit: 'contain', borderRadius: 2 }}
                        priority
                    />
                )}
                <Typography variant="body10" style={{ color: '#374151', fontWeight: 500 }}>
                    {chosedLang?.code?.toUpperCase()}
                </Typography>
                <ChevronDown
                    size={12}
                    color="#6b7280"
                    style={{
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform .2s',
                    }}
                />
            </button>

            {/* Dropdown */}
            {open && (
                <div
                    style={{
                        position: 'absolute',
                        top: 'calc(100% + 6px)',
                        right: 0,
                        background: '#fff',
                        borderRadius: 10,
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        minWidth: 120,
                        zIndex: 100,
                    }}
                >
                    {languages?.map((lng, ind) => {
                        const isActive = lng.code === chosedLang?.code;
                        return (
                            <div
                                key={ind}
                                onClick={() => handleSelect(lng)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '9px 14px',
                                    cursor: 'pointer',
                                    background: isActive ? '#f3f4f6' : 'transparent',
                                    transition: 'background .12s',
                                }}
                                onMouseEnter={(e) => {
                                    if (!isActive) e.currentTarget.style.background = '#f9fafb';
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                {lng.flagUrl && (
                                    <Image
                                        width={18}
                                        height={18}
                                        src={lng.flagUrl}
                                        alt={lng.name}
                                        style={{ objectFit: 'contain', borderRadius: 2 }}
                                        priority
                                    />
                                )}
                                <span
                                    style={{
                                        fontSize: 13,
                                        color: isActive ? '#111827' : '#374151',
                                        fontWeight: isActive ? 600 : 400,
                                    }}
                                >
                                    {lng.name}
                                </span>
                                {isActive && (
                                    <span
                                        style={{
                                            marginLeft: 'auto',
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: 'hsl(var(--primary))',
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LanguageChanger;
